// extracted by mini-css-extract-plugin
export default {"button":"MyButton_button__PH4Vu","slideIn":"MyButton_slideIn__V8TPJ"};